import { render } from "./ChuNeng.vue?vue&type=template&id=1c9970d5&scoped=true"
import script from "./ChuNeng.vue?vue&type=script&lang=js"
export * from "./ChuNeng.vue?vue&type=script&lang=js"

import "./ChuNeng.vue?vue&type=style&index=0&id=1c9970d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9970d5"]])

export default __exports__